import React from 'react';
import NumberInfo from 'ant-design-pro/lib/NumberInfo';
import 'ant-design-pro/dist/ant-design-pro.css'
import { Card, message } from 'antd';
import API, { getAxiosInstance } from '../../api/api';
import moment from 'moment';

export class CustomersToday extends React.Component {
    state = {
        loading: true,
        today:0,
        yesterday:0
    }
    componentDidMount = () => {
        this.setState({ loading: true });
        getAxiosInstance().post(API.users_count, {
            from: moment().subtract(1, 'day'),
            to: moment().endOf('day'),
            criteria: 1

        }).then(({ data }) => {
            if (data.status) {
                const yesterday = data.data.list[0].count;
                const today = data.data.list[1].count;

                this.setState({ yesterday, today,loading:false });
            }
        }).catch((err) => {
            console.error(err);
            message.error('Something went wrong');
        });
    }
    render() {
        const { today, yesterday } = this.state;
        return (
            <Card loading={this.state.loading}>
                <NumberInfo
                    subTitle={<h3>Customers Today</h3>}
                    total={today}
                    status={today>yesterday?"up":"down"}
                    subTotal={Math.abs(yesterday-today)}
                />
            </Card>
        )
    }
}